import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '../../services/API/api.service';
import { AlertService } from '../../services/Alert/alert.service';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent implements OnInit {
  isEditing = false;
  originalAddress: any;
  addressForm!: FormGroup;
  informationDetailsForm!: FormGroup;
  isLoading: boolean = false;
  allAddresses: any[] = [];
  myAddresse: any
  addressesLength: number = 0
  guestMode: boolean = false;
  token?: string = ''
  isGuestMode?: string = ''
  mainAddress?: any
  orderId?: string = ''
  paymentMethod: string = '';

  couponValue: number = 0;
  couponCode: string = '';
  couponType: string = 'percentage';
  deliveyOption: string = ''

  checkoutFormWithToken!: FormGroup;
  checkoutFormWithoutToken!: FormGroup;

  // Add these new properties for custom products
  cartCustomProducts: any[] = [];

  constructor(
    private fb: FormBuilder, 
    private router: Router,
    private apiService: ApiService,
    private alertService: AlertService
  ) {
    this.addressForm = this.fb.group({
      country_id: ['', Validators.required],
      city_id: ['', Validators.required],
      address: ['', Validators.required],
      building: [''],
      floor: [''],
      flat: [''],
      special_mark: [''],
      longitude: [''],
      latitude: ['']
    });

    this.token = localStorage.getItem('romaPizza_token')?.toString();
    this.isGuestMode = sessionStorage.getItem('guestMode');
    
    this.deliveyOption = localStorage.getItem('deliveryOption');
    if(!this.deliveyOption){
      localStorage.setItem('deliveryOption','delivery')
    }
  }

  changeDeliveryMethod(option: string){
    localStorage.setItem('deliveryOption',option)
    if(option == 'pickup'){
      this.checkoutFormWithToken.patchValue({
        deliveryMethod: 'pickup'
      })
      this.checkoutFormWithoutToken.patchValue({
        deliveryMethod: 'pickup'
      })
      this.delivery_fees = 0;
      this.setEmptyAddress()
    }else{
      this.checkoutFormWithToken.patchValue({
        deliveryMethod: 'delivery'
      })
      this.checkoutFormWithoutToken.patchValue({
        deliveryMethod: 'delivery'
      })
      this.setAddressReady()
      this.getTaxSetting()
      this.initAutocomplete()
    }
    this.calculateTotals();
  }

  setAddressReady(){
    this.addressForm.patchValue({
      address: '',
      longitude: '',
      latitude: '',
      country_id: null,
      city_id: null,
    })
    setTimeout(() => {
      $('#addressForm').removeClass('d-none')
      $('#addressForm').addClass('d-block')
    }, 500);
  }
  setEmptyAddress(){
    this.addressForm.patchValue({
      address: '-',
      longitude: '1',
      latitude: '1',
      country_id: 1,
      city_id: 1,
    })
  }

  async ngOnInit(): Promise<void> {
    this.paymentMethod = localStorage.getItem('paymentMethod')
    // this.paymentMethod = 'cash';
    this.initializeForm();
    this.initiaseCheckoutForm()
    this.allCountriesFunction()
    const token = localStorage.getItem('romaPizza_token')?.toString();
    const guestMode = sessionStorage.getItem('guestMode');
    if(token){
      this.myAddressesFunction()
      this.loadMyProfileDetails()
      this.getCartItems();
      this.getCartCustomProducts();
    }else if(guestMode){
      this.guestMode = true;
      this.loadGuestAddresses();
      this.loadGuestCart();
      this.loadGuestCustomCart();
    }else{
      this.alertService.danger('You must be logged in or continue as a guest to start the checkout process');
    }
    this.initAutocomplete()
    this.couponApplyFunction()
    this.getTaxSetting()
  }

initiaseCheckoutForm() {
  this.checkoutFormWithToken = this.fb.group({
    vendor: this.fb.group({
      id: [1, Validators.required],
      name: ['wings_bayonneromaPizza', Validators.required],
      avatar: ['avatar.png']
    }),
    products: this.fb.array([]),
    custom_products: this.fb.array([]), // Add this new FormArray
    address: ['', Validators.required],
    deliveryPhone: ['', [Validators.required, Validators.pattern(/^\+?[0-9]{10,15}$/)]],
    payMethod: [this.paymentMethod, Validators.required],
    deliveryMethod: ['', Validators.required],
    deliveryNote: [''],
    delivery_tips: [0, [Validators.min(0)]],
    longitude: [''],
    latitude: [''],
    totalCost: [0, [Validators.required, Validators.min(0)]],
    copon_id: ['']
  });

  this.checkoutFormWithoutToken = this.fb.group({
    vendor: this.fb.group({
      id: [1, Validators.required],
      name: ['wings_bayonneromaPizza', Validators.required],
      avatar: ['avatar.png']
    }),
    products: this.fb.array([]),
    custom_products: this.fb.array([]), // Add this new FormArray
    address: ['', Validators.required],
    deliveryPhone: ['', [Validators.required, Validators.pattern(/^\+?[0-9]{10,15}$/)]],
    payMethod: [this.paymentMethod, Validators.required],
    deliveryMethod: ['', Validators.required],
    deliveryNote: [''],
    delivery_tips: [0, [Validators.min(0)]],
    longitude: [''],
    latitude: [''],
    totalCost: [0, [Validators.required, Validators.min(0)]],
    copon_id: [''],
    fullname: ['', [Validators.required]],
    email: ['', [Validators.required, Validators.email]]
  });
}

  couponApplyFunction(){
    const couponApplied = localStorage.getItem('couponApplied');
    if(couponApplied){
      this.couponApplied = true;
      this.couponValue = parseFloat(localStorage.getItem('couponValue'));
      this.couponCode = localStorage.getItem('couponCode');
      this.couponType = localStorage.getItem('couponType');
      this.calculateTotals();
    }
  }

  initializeForm(): void {
    this.informationDetailsForm = this.fb.group({
      fullname: ['', [Validators.required]],
      phoneNumber: ['', [Validators.required, Validators.pattern(/^\+?[0-9]{10,15}$/)]],
      email: ['', [Validators.required, Validators.email]],
      note: ['']
    });
  }

  allCountries: any
  countriesLength: number = 0
  selectedCountryId: number | null = null;
  cities: any[] = [];
  citySelected: boolean = false;
  setNewAddress: boolean = false;
  allCountriesFunction(){
    this.apiService.countries(1).subscribe({
      next: response => {
        this.allCountries = response.data;
        this.countriesLength = this.allCountries.length;
      }, 
      error: (error: any) => {
        this.alertService.danger(error.error.message);
        this.allCountries = [];
      }
    });
  }
  onCountryChange(countryId: any) {
    this.selectedCountryId = countryId.value;
    const selectedCountry = this.allCountries.find(c => c.id == this.selectedCountryId);
    this.cities = selectedCountry ? selectedCountry.cities : [];
    this.citySelected = true;
  }
  myAddressesFunction(){
    this.isLoading = true;
    this.apiService.myAddresses().subscribe({
      next: response => {
        this.myAddresse = response.data.myAddresses[0].address;
        this.allAddresses = response.data.myAddresses;
        this.addressesLength = response.data.myAddresses.length;
        this.isLoading = false;
        this.mainAddressSets()
      }, 
      error: (error: any) => {
        this.alertService.danger(error.error.message);
        this.allAddresses = [];
        this.isLoading = false;
      }
    });
  }
  setAsMain(addressId: number): void {
    if (this.isLoading) return;
    
    const currentMainAddress = this.allAddresses?.find(a => a.isMain);
    
    if (currentMainAddress && currentMainAddress.id === addressId) {
      this.alertService.danger('This is already your main address');
      return;
    }

    this.isLoading = true;
    this.apiService.setMainAddress(addressId).subscribe({
      next: () => {
        this.allAddresses = this.allAddresses?.map(address => ({
          ...address,
          isMain: address.id === addressId
        })) || null;
        
        this.alertService.success('Main address updated successfully');
        this.isLoading = false;
        this.mainAddressSets()
      },
      error: (error) => {
        this.alertService.danger(error.error?.message || 'Failed to update main address');
        this.isLoading = false;
      }
    });
  }
  deleteAddress(addressId: number): void {
    if (confirm('Are you sure you want to delete this address?')) {
      this.apiService.deleteAddress(addressId).subscribe({
        next: () => {
          this.alertService.success('Address deleted successfully');
          this.myAddressesFunction();
        },
        error: (error) => {
          this.alertService.danger(error.error?.message || 'Failed to delete address');
        }
      });
    }
  }
  addNewAddress(){
    this.setNewAddress = !this.setNewAddress;
    if(this.setNewAddress){
      $('#addressForm').removeClass('d-none')
      $('#addressForm').addClass('d-block')
      $('#AddNewAddress').text('Remove Adding');
    }else{
      $('#addressForm').removeClass('d-block')
      $('#addressForm').addClass('d-none')
      $('#AddNewAddress').text('Add New Address')
    }
  }

  saveAddress(): void {
    if (this.informationDetailsForm.valid) {
      this.isEditing = false;
      this.informationDetailsForm.disable();
    }
  }

  cancelEdit(): void {
    this.isEditing = false;
    this.informationDetailsForm.patchValue(this.originalAddress);
    this.informationDetailsForm.disable();
  }
  profileDetails: any
  loadMyProfileDetails(){
    this.apiService.myProfile().subscribe({
      next: response => {
        this.profileDetails = response.data;
        this.informationDetailsForm.patchValue({
          fullname: this.profileDetails.name,
          phoneNumber: this.profileDetails.phone,
          email: this.profileDetails.email
        })
        this.phoneNumber = this.profileDetails.phone;
      }, 
      error: (error: any) => {
        this.alertService.danger(error.error.message);
      }
    });
  }

  getCartCustomProducts() {
    this.apiService.getCartCustomProducts().subscribe({
      next: (response: any) => {
        if (response.success && response.data?.data) {
          this.cartCustomProducts = response.data.data;
          this.addCustomProductsToForm();
        }
      }, 
      error: (error: any) => {
        console.error('Error loading custom products:', error);
      }
    });
  }

  loadGuestCustomCart() {
    const customCartItems = sessionStorage.getItem('customCartItems');
    if (customCartItems) {
      this.cartCustomProducts = JSON.parse(customCartItems);
      const cartItemsCount = this.cartCustomProducts.length + this.cartItems.length;
      console.log('Loaded custom cart items:', cartItemsCount);
      if(cartItemsCount == 0) {
        this.alertService.danger('Please choose at least one item to proceed');
        this.router.navigate(['/mainMenu']);
      }
      this.addCustomProductsToForm();
    }else{
      const cartItemsCount = this.cartCustomProducts.length + this.cartItems.length;
      console.log('Loaded custom cart items:', cartItemsCount);
      if(cartItemsCount == 0) {
        this.alertService.danger('Please choose at least one item to proceed');
        this.router.navigate(['/mainMenu']);
      }
    }
  }

addCustomProductsToForm() {
  const customProductsArrayWithToken = this.checkoutFormWithToken.get('custom_products') as FormArray;
  const customProductsArrayWithoutToken = this.checkoutFormWithoutToken.get('custom_products') as FormArray;
  
  // Clear existing custom products
  customProductsArrayWithToken.clear();
  customProductsArrayWithoutToken.clear();
  
  this.cartCustomProducts.forEach(item => {
    // Create the custom product object in the required format
    const customProductGroup = this.fb.group({
      category: this.fb.group({
        id: [item.customProducts?.category?.id || null],
        name: [item.customProducts?.category?.name || ''],
        default_size: [item.customProducts?.category?.default_size || null],
        has_sizes: [item.customProducts?.category?.has_sizes || null],
        default_price: [item.customProducts?.category?.default_price || null],
        avatar: [item.customProducts?.category?.avatar || ''],
        selected_size: [item.customProducts?.category?.selected_size || null]
      }),
      subCategory: this.fb.group({
        id: [item.customProducts?.subCategory?.id || null],
        name: [item.customProducts?.subCategory?.name || ''],
        avatar: [item.customProducts?.subCategory?.avatar || '']
      }),
      ingredients: this.fb.array(this.createIngredientsArray(item.customProducts?.ingredients || [])),
      isHalfAndHalf: [item.customProducts?.isHalfAndHalf || false],
      totalPrice: [item.customProducts?.totalPrice || 0],
      quantity: [item.quantity || 1]
    });
    
    customProductsArrayWithToken.push(customProductGroup);
    customProductsArrayWithoutToken.push(customProductGroup);
  });

  this.calculateTotals();
}
createIngredientsArray(ingredients: any[]): FormGroup[] {
  return ingredients.map(ingredient => 
    this.fb.group({
      id: [ingredient.id || null],
      name: [ingredient.name || ''],
      price: [ingredient.price || 0],
      quantity: [ingredient.quantity || 1],
      half: [ingredient.half || 'whole'],
      totalPrice: [ingredient.totalPrice || 0],
      sizeId: [ingredient.sizeId || null]
    })
  );
}


  // Helper methods for custom products
  getCustomProductName(customItem: any): string {
    if (!customItem || !customItem.customProducts) return 'Custom Product';
    
    const customProducts = customItem.customProducts;
    const categoryName = customProducts.category?.name || '';
    const subCategoryName = customProducts.subCategory?.name || '';
    
    if (categoryName && subCategoryName) {
      return `Custom ${categoryName}`;
    } else if (categoryName) {
      return `Custom ${categoryName}`;
    }
    return 'Custom Product';
  }

  getCustomProductImage(customItem: any): string {
    if (!customItem || !customItem.customProducts) return 'assets/images/default-food.png';
    
    const customProducts = customItem.customProducts;
    return customProducts.category?.avatar || customProducts.subCategory?.avatar || 'assets/images/default-food.png';
  }

  getCustomProductSize(customItem: any): string {
    if (!customItem || !customItem.customProducts) return '';
    
    const customProducts = customItem.customProducts;
    if (customProducts.category?.selected_size) {
      return customProducts.category.selected_size.name;
    } else if (customProducts.category?.has_sizes === 0) {
      return 'Regular';
    }
    return '';
  }

  getCustomProductPrice(customItem: any): number {
    if (!customItem || !customItem.customProducts) return 0;
    return customItem.customProducts.totalPrice || 0;
  }

  getCustomProductTotalPrice(customItem: any): number {
    if (!customItem) return 0;
    const price = this.getCustomProductPrice(customItem);
    return price * (customItem.quantity || 1);
  }

  isHalfAndHalf(customItem: any): boolean {
    return customItem?.customProducts?.isHalfAndHalf || false;
  }

  getLeftHalfIngredients(customItem: any): any[] {
    if (!customItem || !customItem.customProducts || !customItem.customProducts.ingredients) {
      return [];
    }
    return customItem.customProducts.ingredients.filter(
      (ing: any) => ing.half === 'left' || ing.half === 'whole'
    );
  }

  getRightHalfIngredients(customItem: any): any[] {
    if (!customItem || !customItem.customProducts || !customItem.customProducts.ingredients) {
      return [];
    }
    return customItem.customProducts.ingredients.filter(
      (ing: any) => ing.half === 'right' || ing.half === 'whole'
    );
  }

  getAllIngredients(customItem: any): any[] {
    return customItem?.customProducts?.ingredients || [];
  }

  formatIngredientDisplay(ingredient: any): string {
    if (!ingredient) return '';
    
    let display = ingredient.name || 'Ingredient';
    if (ingredient.quantity && ingredient.quantity > 1) {
      display += ` (${ingredient.quantity}x)`;
    }
    if (ingredient.half && ingredient.half !== 'whole') {
      display += ` - ${ingredient.half} half`;
    }
    return display;
  }

  saveGuestCustomCart() {
    sessionStorage.setItem('customCartItems', JSON.stringify(this.cartCustomProducts));
  }

refreshProductsForm() {
  // Clear existing products
  const productsArrayWithToken = this.checkoutFormWithToken.get('products') as FormArray;
  const productsArrayWithoutToken = this.checkoutFormWithoutToken.get('products') as FormArray;
  const customProductsArrayWithToken = this.checkoutFormWithToken.get('custom_products') as FormArray;
  const customProductsArrayWithoutToken = this.checkoutFormWithoutToken.get('custom_products') as FormArray;
  
  productsArrayWithToken.clear();
  productsArrayWithoutToken.clear();
  customProductsArrayWithToken.clear();
  customProductsArrayWithoutToken.clear();
  
  // Re-add regular products
  this.addCartItemsToForm();
  
  // Re-add custom products
  this.addCustomProductsToForm();
}

// Update removeCustomItem method
removeCustomItem(index: number) {
  const itemId = this.cartCustomProducts[index]?.id;
  const guestMode = sessionStorage.getItem('guestMode');
  const token = localStorage.getItem('romaPizza_token')?.toString();
  
  if(token && itemId) {
    this.apiService.removeCartItem(itemId).subscribe({
      next: () => {
        this.cartCustomProducts.splice(index, 1);
        this.refreshProductsForm();
        this.calculateTotals();
        this.alertService.success('Item removed from cart');
      },
      error: (error) => {
        this.alertService.danger(error.error?.message || 'Failed to remove item');
      }
    });
  } else if (guestMode) {
    this.cartCustomProducts.splice(index, 1);
    this.saveGuestCustomCart();
    this.refreshProductsForm();
    this.calculateTotals();
    this.alertService.success('Item removed from cart');
  }
}


  // Rest of your existing methods remain the same...
  
  get subtotal(): number {
    return this.cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  }

  private _discount: number = 0;

  get total(): number {
    return this.subtotal - this.discount;
  }

  phoneNumber: string = ''
  note: string = ''
  isLoadingPlaceOrder: boolean = false

  placeOrder(): void {
    if(this.paymentMethod == 'cash' || this.paymentMethod == 'Cash'){
      this.placeOrderWithCash()
      return;
    }
    if(this.deliveyOption == 'pickup'){
      this.setEmptyAddress()
    }
    const number = this.phoneNumber.replace(/\D/g, '');
    this.isLoadingPlaceOrder = true
    this.checkoutFormWithToken.patchValue({
      deliveryNote: this.note,
      deliveryPhone: number,
      copon_id: localStorage.getItem('couponId'),
      deliveryMethod: localStorage.getItem('deliveryOption')
    })
    
    const token = localStorage.getItem('romaPizza_token')?.toString();
    if(token){
      this.checkoutFormWithToken.patchValue({
        address: this.mainAddress.address,
        longitude: this.mainAddress.longitude,
        latitude: this.mainAddress.latitude
      })
    }
    this.informationDetailsForm.markAllAsTouched();
    console.log(this.checkoutFormWithToken.value)
    if(this.checkoutFormWithToken.valid){
      this.apiService.confirmOrder(this.checkoutFormWithToken.value).subscribe({
        next: (response) => {
          this.orderId = response.data.id;
          this.alertService.success(response.message);
          const url = response.data.url;
          window.location.href = url
        }, 
        error: (error) => {
          this.alertService.danger(error.error.message);
          this.isLoadingPlaceOrder = false
        }
      });
    }
    // else{
    //     this.alertService.danger('Please fill card details');
    //     this.isLoadingPlaceOrder = false
    // }
  }

  dataSubmittedSuccessfully: boolean = false;
  
  placeOrderWithoutToken(): void {
    this.isLoadingPlaceOrder = true
    if(this.paymentMethod == 'cash' || this.paymentMethod == 'Cash'){
      this.placeOrderWithoutTokenWithCash()
      return;
    }
    if(this.deliveyOption == 'pickup'){
      this.setEmptyAddress()
    }
    this.checkoutFormWithoutToken.patchValue({
      deliveryNote: this.informationDetailsForm.get('note')?.value,
      deliveryPhone: this.informationDetailsForm.get('phoneNumber')?.value,
      fullname: this.informationDetailsForm.get('fullname')?.value,
      email: this.informationDetailsForm.get('email')?.value,
      copon_id: localStorage.getItem('couponId'),
      address: this.addressForm.get('address')?.value,
      longitude: this.addressForm.get('longitude')?.value,
      latitude: this.addressForm.get('latitude')?.value,
      deliveryMethod: localStorage.getItem('deliveryOption')
    })
    console.log(this.checkoutFormWithoutToken.value)
    if(this.isGuestMode && this.checkoutFormWithoutToken.valid){
        this.apiService.confirmOrderWithoutToken(this.checkoutFormWithoutToken.value).subscribe({
          next: (response) => {
            this.orderId = response.data.id;
            this.alertService.success(response.message);
            this.dataSubmittedSuccessfully = true;
            const url = response.data.url;
            window.location.href = url
          }, 
          error: (error) => {
            this.dataSubmittedSuccessfully = false;
            this.alertService.danger(error.error.message);
            this.isLoadingPlaceOrder = false
          }
        });
    }else{
      if(this.checkoutFormWithoutToken.get('address')?.value == "" || 
        this.checkoutFormWithoutToken.get('longitude')?.value == "" || 
        this.checkoutFormWithoutToken.get('latitude')?.value == "" || 
        this.checkoutFormWithoutToken.get('deliveryPhone')?.value == "" || 
        this.checkoutFormWithoutToken.get('payMethod')?.value == "" || 
        this.checkoutFormWithoutToken.get('deliveryMethod')?.value == "" || 
        this.addressForm.get('country_id')?.value == "" || 
        this.addressForm.get('city_id')?.value == ""){
          this.alertService.danger('Please fill all required fields');
      }
      this.isLoadingPlaceOrder = false
    }
  }

  // tips section
  tipPercentages = [15, 20, 25, 30];
  selectedTip: number | 'custom' | null = null;
  customTipAmount: number | null = null;

  selectTip(percent: number) {
    this.selectedTip = percent;
    this.customTipAmount = null;
    this.calculateTotals()
  }

  selectCustomTip() {
    this.selectedTip = 'custom';
    setTimeout(() => {
      const input = document.querySelector('.custom-tip-input') as HTMLInputElement;
      input?.focus();
    }, 0);
    this.calculateTotals()
  }

  resetTips() {
    this.selectedTip = null;
    this.customTipAmount = null;
  }

  getSelectedTipValue(): number | null {
    if (this.selectedTip === 'custom') {
      return this.customTipAmount;
    }
    return this.selectedTip;
  }

  // map
  autocomplete!: google.maps.places.Autocomplete;
  selectedLat: number = 0;
  selectedLng: number = 0;
  placeName: string = '';
  private bayonneDeliveryZone = [
    {lat:40.642, lng:-74.148},
    {lat:40.650, lng:-74.086},
    {lat:40.727, lng:-74.020},
    {lat:40.737, lng:-74.086},
    {lat:40.642, lng:-74.148}
  ];
  
  initAutocomplete(): void {
    setTimeout(() => {
      if(this.deliveyOption == 'delivery'){
      const input = document.getElementById('addressInput1') as HTMLInputElement;
      this.autocomplete = new google.maps.places.Autocomplete(input, {
        componentRestrictions: { country: 'us' },
        fields: ['geometry', 'formatted_address', 'address_components']
      });

      this.autocomplete.addListener('place_changed', async () => {
        const place = this.autocomplete.getPlace();
        if (!place.geometry) {
          this.alertService.danger('Please select a valid address from the suggestions');
          return;
        }

        const allowedLocalities = ['Garwood', 'Westfield', 'Cranford'];
        const inBayonne = place.address_components?.some(comp => 
          (comp.types.includes('locality') && allowedLocalities.includes(comp.long_name)) ||
          (comp.types.includes('postal_code') && ['07027', '07090', '07016'].some(zip => comp.long_name.startsWith(zip))
        ));
        console.log('Address components:', place.address_components);
        if (!inBayonne) {
          this.handleOutOfZone(input);
          return;
        }

        const location = place.geometry.location;
        const isInZone = await this.checkDeliveryZone(location.lat(), location.lng());
        
        if (!inBayonne) {
          this.handleOutOfZone(input);
        } else {
          this.selectedLat = location.lat();
          this.selectedLng = location.lng();
          this.placeName = place.formatted_address;
          this.addressForm.patchValue({
            address: this.placeName,
            longitude: this.selectedLng.toString(),
            latitude: this.selectedLat.toString()
          });
        }
      });
    }
    }, 400);
  }
  
  private handleOutOfZone(input: HTMLInputElement): void {
    this.alertService.danger('Sorry, we only deliver within Garwood, Westfield, and Cranford, NJ');
    this.addressForm.patchValue({
      address: '',
      longitude: null,
      latitude: null
    });
    input.value = '';
    this.selectedLat = null;
    this.selectedLng = null;
    this.placeName = '';
  }
  
  private isPointInPolygon(point: {lat: number, lng: number}, polygon: any[]): boolean {
    let inside = false;
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      const xi = polygon[i].lat, yi = polygon[i].lng;
      const xj = polygon[j].lat, yj = polygon[j].lng;
      
      const intersect = ((yi > point.lng) !== (yj > point.lng)) &&
        (point.lat < (xj - xi) * (point.lng - yi) / (yj - yi) + xi);
      if (intersect) inside = !inside;
    }
    return inside;
  }
  
  async checkDeliveryZone(lat: number, lng: number): Promise<boolean> {
    const inBounds = this.isInBayonneBounds(lat, lng);
    const inPolygon = this.isPointInPolygon({lat, lng}, this.bayonneDeliveryZone);
    return inPolygon;
  }
  
  private isInBayonneBounds(lat: number, lng: number): boolean {
    return (
      lat >= 40.6412 &&
      lat <= 40.6689 &&
      lng >= -74.1147 &&
      lng <= -74.0279
    );
  }

  submitAddress() {
    if (this.addressForm.invalid) {
      this.addressForm.markAllAsTouched();
      this.alertService.danger('Please fill all required fields');
      return;
    }

    const address: any = {
      city_id: this.addressForm.value.city_id,
      address: this.addressForm.value.address,
      latitude: this.addressForm.value.latitude,
      longitude: this.addressForm.value.longitude
    };

    if (this.addressForm.value.building) {
      address.building = this.addressForm.value.building;
    }
    if (this.addressForm.value.floor) {
      address.floor = this.addressForm.value.floor;
    }
    if (this.addressForm.value.flat) {
      address.flat = this.addressForm.value.flat;
    }
    if (this.addressForm.value.special_mark) {
      address.special_mark = this.addressForm.value.special_mark;
    }

    this.isLoading = true;
    this.apiService.addAddress(address).subscribe({
      next: (response) => {
        this.alertService.success(response.message);
        this.myAddressesFunction();
        this.addressForm.reset();
        this.isLoading = false;
      },
      error: (error) => {
        this.alertService.danger(error.error?.message || 'Failed to add address');
        this.isLoading = false;
      }
    });
  }

  mainAddressSets(){
    const addressSelected = this.allAddresses.find(address => address.isMain == true);
    this.mainAddress = addressSelected;
  }

  taxValue: number = 0;
  taxType: string = '';
  feeValue: number = 0;
  feeType: string = '';
  delivery_fees: number = 0;
  settings: any = {};
  
  getTaxSetting(){
    this.apiService.vendorSettings().subscribe({
      next: response => {
        this.taxValue = response.settings.tax_value;
        this.taxType = response.settings.tax_type;
        this.feeValue = parseFloat(response.settings.fee_value);
        this.feeType = response.settings.fee_type;
        this.settings = response.settings;
        const isOpen = response.settings.is_open;
        if(isOpen == false){
          this.alertService.danger('This vendor is currently closed.');
          setTimeout(() => {
            this.router.navigate(['/out-of-service']);
          }, 1000);
        }
        if(this.token){
          this.getCartItems()
        }else if(this.isGuestMode){
          // this.loadGuestCart();
          this.calculateDeliveryFees();
        }
      }, 
      error: (error: any) => {
      }
    });
  }

  calculateDeliveryFees() {
    this.delivery_fees = 0;
    if (this.cartItems.length > 0) {
      const hasCateringItem = this.cartItems.some(item => item.category_name == 'Catering');  
      if (hasCateringItem) {
        this.delivery_fees = parseFloat(this.settings.catering_delivery_fees);
      } else {
        this.delivery_fees = parseFloat(this.settings.delivery_fees);
      }
      const option = localStorage.getItem('deliveryOption')
      if(option == 'pickup'){
        this.delivery_fees = 0;
      }
    }
  }

  loadGuestCart() {
    this.isLoading = true;
    const cartItems = sessionStorage.getItem('cartItems');
    if (cartItems) {
      this.cartItems = JSON.parse(cartItems);
      this.cartItems = this.cartItems;
      this.cartItems.forEach(item => {
        const extras = item.selectedExtraId && Array.isArray(item.selectedExtraId) 
            ? item.selectedExtraId.map(extra => ({
                name: extra.name,
                quantity: extra.quantity,
                price: extra.price
            }))
            : [];

        const sides = item.selectedFreeSides && Array.isArray(item.selectedFreeSides)
            ? item.selectedFreeSides.map(side => ({
                id: side.id,
                name: side.name,
                price: side.price
            }))
            : [];

        this.addProduct({
            name: item.name,
            type: item.selectedTypeId ? 
                item.types.find((t: any) => t.id === item.selectedTypeId)?.name : 
                item.types[0]?.name || '',
            quantity: item.quantity,
            price: item.types.find((t: any) => t.id === item.selectedTypeId)?.price,
            avatar: item.avatar,
            extras: extras,
            sides: sides
        });
      });
      this.cartItemsLength = this.cartItems.length;
      this.calculateTotals();
      // if(cartItems.length == 0){
        
      // }
    }
    // else{
    //   this.alertService.danger('Please choose at least one item to proceed');
    //   this.router.navigate(['/mainMenu']);
    // }
    this.isLoading = false;
  }

  addCartItemsToForm() {
    const productsArrayWithToken = this.checkoutFormWithToken.get('products') as FormArray;
    const productsArrayWithoutToken = this.checkoutFormWithoutToken.get('products') as FormArray;
    
    productsArrayWithToken.clear();
    productsArrayWithoutToken.clear();
    
    const uniqueProducts = new Map();
    
    this.cartItems.forEach(item => {
        const key = this.generateProductKey(item);
        
        const extras = item.selectedExtraId && Array.isArray(item.selectedExtraId) 
            ? item.selectedExtraId.map(extra => ({
                name: extra.name,
                quantity: extra.quantity,
                price: extra.price
            }))
            : [];

        const sides = item.selectedFreeSides && Array.isArray(item.selectedFreeSides)
            ? item.selectedFreeSides.map(side => ({
                id: side.id,
                name: side.name,
                price: side.price
            }))
            : [];

        const productType = item.selectedTypeId ? 
            item.types.find((t: any) => t.id === item.selectedTypeId)?.name : 
            item.types[0]?.name || '';

        const productPrice = item.types.find((t: any) => t.id === item.selectedTypeId)?.price;

        if (uniqueProducts.has(key)) {
            const existingProduct = uniqueProducts.get(key);
            existingProduct.quantity += item.quantity;
        } else {
            uniqueProducts.set(key, {
                name: item.name,
                type: productType,
                quantity: item.quantity,
                price: productPrice,
                avatar: item.avatar,
                extras: extras,
                sides: sides,
                isCustom: false
            });
        }
    });
    
    uniqueProducts.forEach(product => {
        this.addProduct(product);
    });
    console.log('Final products without duplication:', uniqueProducts);
  }

  generateProductKey(item: any): string {
    const sortedSides = item.selectedFreeSides && Array.isArray(item.selectedFreeSides)
        ? [...item.selectedFreeSides].sort((a, b) => a.id - b.id).map(side => side.id).join(',')
        : '';

    const sortedExtras = item.selectedExtraId && Array.isArray(item.selectedExtraId)
        ? [...item.selectedExtraId].sort((a, b) => a.id - b.id).map(extra => `${extra.id}:${extra.quantity}`).join(',')
        : '';

    return `${item.name}-${item.selectedTypeId}-[${sortedSides}]-[${sortedExtras}]`;
  }

  addProduct(product: {
      name: string,
      type: string,
      quantity: number,
      price: number,
      avatar: string,
      extras: any[],
      sides: any[],
      isCustom?: boolean,
      customData?: any
  }) {
      const productGroup = this.fb.group({
          name: [product.name, Validators.required],
          type: [product.type, Validators.required],
          quantity: [product.quantity, [Validators.required, Validators.min(1)]],
          price: [product.price, [Validators.required, Validators.min(0)]],
          avatar: [product.avatar],
          extras: [product.extras],
          sides: [product.sides],
          isCustom: [product.isCustom || false],
          customData: [product.customData || null]
      });
      
      (this.checkoutFormWithToken.get('products') as FormArray).push(productGroup);
      (this.checkoutFormWithoutToken.get('products') as FormArray).push(productGroup);
  }

  // cart functions
  cartItems: any[] = [];
  cartItemsLength: number = 0;
  subtotalCart: number = 0;
  totalCart: number = 0;
  couponApplied: boolean = false;
  couponDiscount: number = 0;
  
  getCartItems() {
    this.isLoading = true;
    this.apiService.getCart().subscribe({
      next: response => {
        this.cartItems = response.data.data;
        this.cartItemsLength = this.cartItems.length + this.cartCustomProducts.length;
        setTimeout(() => {
          this.calculateDeliveryFees();
          this.calculateTotals();
        }, 500);
        this.isLoading = false;
        this.addCartItemsToForm();
      }, 
      error: (error: any) => {
        this.alertService.danger(error.error.message);
        this.isLoading = false;
      }
    });
  }

  calculateTotals() {
    this.calculateSubtotal();
    this.calculateTax();
    this.calculateFee();
    this.calculateTip();
    setTimeout(() => {
      if(this.calculateSubtotal() && this.calculateTax() && this.calculateFee()){
        this.calculateFinalTotal();
      }
    }, 1000);
  }

  taxAmount: number = 0;
  feeAmount: number = 0;
  tipAmount: number = 0;
  discountFromOffers: number = 0; 
  
  private calculateSubtotal(): boolean {
    // Calculate regular items subtotal
    const regularSubtotal = this.cartItems.reduce((sum, item) => {
        const itemPrice = this.getItemPrice(item);
        const quantity = item.quantity || 0;
        return sum + (itemPrice * quantity);
    }, 0);
    
    // Calculate custom products subtotal
    const customSubtotal = this.cartCustomProducts.reduce((sum, item) => {
        return sum + this.getCustomProductTotalPrice(item);
    }, 0);
    
    this.subtotalCart = regularSubtotal + customSubtotal;
    
    // Calculate total discount from offers (only for regular items)
    this.discountFromOffers = this.cartItems.reduce((sum, item) => {
        if (item.offer) {
            const originalPrice = this.getOriginalItemPrice(item);
            const discountedPrice = this.getItemPrice(item);
            return sum + ((originalPrice - discountedPrice) * item.quantity);
        }
        return sum;
    }, 0);

    return true;
  }

  private calculateTax(): boolean {
    if (this.taxType === 'fixed') {
      this.taxAmount = this.taxValue || 0;
    } else {
      const taxPercentage = this.taxValue || 0;
      this.taxAmount = this.subtotalCart * (taxPercentage / 100);
    }
    return true;
  }

  private calculateFee(): boolean {
    if (this.feeType === 'fixed') {
      this.feeAmount = this.feeValue || 0;
    } else {
      const feePercentage = this.feeValue || 0;
      this.feeAmount = this.subtotalCart * (feePercentage / 100);
    }
    return true;
  }

  private calculateTip() {
    if (!this.selectedTip) {
      this.tipAmount = 0;
      return;
    }

    if (this.selectedTip === 'custom' && this.customTipAmount) {
      this.tipAmount = this.customTipAmount || 0;
    } else if (typeof this.selectedTip === 'number') {
      this.tipAmount = this.subtotalCart * (this.selectedTip / 100);
    } else {
      this.tipAmount = 0;
    }
  }

  get discount(): number {
    if(this.couponType == 'percentage'){
      return this.couponApplied ? this.subtotalCart * this.couponValue / 100 : 0;
    }else if(this.couponType == 'value'){
      return this.couponValue;
    }
    return 0;
  }

  getExtraName(item: any, extraId: number): string {
    try {
      if (item && item.extra && Array.isArray(item.extra)) {
        const extra = item.extra.find((e: any) => e.id == extraId);
        if (extra && extra.name) {
          return extra.name;
        }
      }
      
      if (item && item.extraproducts && Array.isArray(item.extraproducts)) {
        const extra = item.extraproducts.find((e: any) => e.id == extraId);
        if (extra && extra.name) {
          return extra.name;
        }
      }
      
      return `Extra #${extraId}`;
    } catch (error) {
      console.error('Error getting extra name:', error);
      return 'Extra';
    }
  }

  getOfferText(item: any): string {
    if (!item.offer) return '';
    
    if (item.offer.type === 'discount') {
        return `Save $${item.offer.value}`;
    }
    else if (item.offer.type === 'percentage') {
        return `${item.offer.value}% OFF`;
    }
    
    return '';
  }

  loadGuestAddresses(){
    this.guestMode = true;
    setTimeout(() => {
      $('#addressForm').removeClass('d-none')
      $('#addressForm').addClass('d-block')
    }, 400);
  }

  // payment method functions
  paymentData = {
    cardHolderName: '',
    cardNumber: '',
    expirationDate: '',
    cardCode: '',
    billingAddress: ''
  };
  
  showAddress(event: any): void {
  }

  formatCardNumber(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, '');
    value = value.replace(/(\d{4})(?=\d)/g, '$1-');
    this.paymentData.cardNumber = value.substring(0, 19);
  }

  formatExpiryDate(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, '');
    
    if (value.length > 2) {
      value = value.substring(0, 2) + '/' + value.substring(2, 4);
    }
    
    this.paymentData.expirationDate = value.substring(0, 5);
  }

  formatPhoneInput(event: any): void {
    let value = event.target.value.replace(/\D/g, '');
    if (value.length > 3) {
      value = value.substring(0, 3) + '-' + value.substring(3, 6);
    }
    if (value.length > 7) {
      value = value.substring(0, 7) + '-' + value.substring(7, 11);
    }
    event.target.value = value;
    this.phoneNumber = value;
  }

  getUniqueExtrasWithCount(item: any): any[] {
    if (!item || !item.selectedExtraId || !Array.isArray(item.selectedExtraId)) {
        return [];
    }
    
    let processedExtras: any[] = [];
    
    if (typeof item.selectedExtraId[0] === 'number') {
        const countMap = new Map<number, number>();
        item.selectedExtraId.forEach((id: number) => {
            countMap.set(id, (countMap.get(id) || 0) + 1);
        });
        
        countMap.forEach((count, id) => {
            const extraInfo = this.getExtraInfo(item, id);
            if (extraInfo) {
                processedExtras.push({
                    id: id,
                    name: extraInfo.name,
                    count: count
                });
            }
        });
    } else {
        const countMap = new Map<number, number>();
        item.selectedExtraId.forEach((extraObj: any) => {
            const id = extraObj.id;
            countMap.set(id, (countMap.get(id) || 0) + 1);
        });
        
        countMap.forEach((count, id) => {
            const extraObj = item.selectedExtraId.find((e: any) => e.id === id);
            if (extraObj) {
                processedExtras.push({
                    id: id,
                    name: extraObj.name,
                    count: count
                });
            }
        });
    }
    
    return processedExtras;
  }

  getExtraInfo(item: any, extraId: number): any {
      if (!item || !item.extraproducts || !Array.isArray(item.extraproducts)) {
          return null;
      }
      return item.extraproducts.find((e: any) => e.id == extraId) || null;
  }
  
  getOriginalItemPrice(item: any): number {
      if (item.selectedTypeId && item.types?.length) {
          const selectedType = item.types.find(t => t.id === item.selectedTypeId);
          return selectedType?.price || 0;
      }
      return item.types?.[0]?.price || item.price || 0;
  }

  getItemPrice(item: any): number {
    const basePrice = this.getOriginalItemPrice(item);
    
    let extrasPrice = 0;
    if (item.selectedExtraId && Array.isArray(item.selectedExtraId)) {
        extrasPrice = item.selectedExtraId.reduce((total: number, extra: any) => {
            return total + (extra.price * extra.quantity);
        }, 0);
    }
    
    let freeSidesPrice = 0;
    if (item.selectedFreeSides && Array.isArray(item.selectedFreeSides)) {
        freeSidesPrice = item.selectedFreeSides.reduce((total: number, side: any) => {
            return total + (side.price || 0);
        }, 0);
    }
    
    const totalBasePrice = basePrice + extrasPrice + freeSidesPrice;
    
    if (!item.offer) return totalBasePrice;
    
    if (item.offer.type === 'discount') {
        return Math.max(0, totalBasePrice - item.offer.value);
    } 
    else if (item.offer.type === 'percentage') {
        return totalBasePrice * (1 - item.offer.value / 100);
    }
    
    return totalBasePrice;
  }

  getItemTotalPrice(item: any): number {
    return this.getItemPrice(item) * item.quantity;
  }

  private calculateFinalTotal() {
    this.totalCart = ((this.taxValue * (this.subtotalCart + this.feeValue))/100) + 
                      (this.tipAmount || 0) + 
                      (this.delivery_fees || 0) - 
                      (this.discount || 0) + 
                      (this.feeAmount || 0) + 
                      this.subtotalCart;

    this.checkoutFormWithToken.patchValue({
        totalCost: parseFloat(this.totalCart.toFixed(2)),
        delivery_tips: this.tipAmount || 0
    });

    if(this.isGuestMode){
        this.checkoutFormWithoutToken.patchValue({
            totalCost: parseFloat(this.totalCart.toFixed(2)),
            delivery_tips: this.tipAmount || 0
        });
    }
  }

  getPriceBreakdown(item: any): any {
    const basePrice = this.getOriginalItemPrice(item);
    
    let extrasPrice = 0;
    if (item.selectedExtraId && Array.isArray(item.selectedExtraId)) {
        extrasPrice = item.selectedExtraId.reduce((total: number, extra: any) => {
            return total + (extra.price * extra.quantity);
        }, 0);
    }
    
    let freeSidesPrice = 0;
    if (item.selectedFreeSides && Array.isArray(item.selectedFreeSides)) {
        freeSidesPrice = item.selectedFreeSides.reduce((total: number, side: any) => {
            return total + (side.price || 0);
        }, 0);
    }
    
    return {
        base: basePrice,
        extras: extrasPrice,
        freeSides: freeSidesPrice,
        unitTotal: basePrice + extrasPrice + freeSidesPrice,
        itemTotal: (basePrice + extrasPrice + freeSidesPrice) * item.quantity
    };
  }

  removeItem(index: number) {
    const itemId = this.cartItems[index].id;
    const guestMode = sessionStorage.getItem('guestMode');
    const token = localStorage.getItem('romaPizza_token')?.toString();

    if(token){
      this.apiService.removeCartItem(itemId).subscribe({
        next: () => {
          this.cartItems.splice(index, 1);
          this.cartItemsLength = this.cartItems.length + this.cartCustomProducts.length;
          this.getCartItems();
          this.refreshProductsForm();
          this.calculateTotals();
          this.alertService.success('Item removed from cart');
        },
        error: (error) => {
          this.alertService.danger(error.error?.message || 'Failed to remove item');
        }
      });
    }else if(guestMode){
      this.cartItems.splice(index, 1);
      this.cartItemsLength = this.cartItems.length + this.cartCustomProducts.length;
      this.saveGuestCart();
      this.refreshProductsForm();
      this.calculateTotals();
      this.alertService.success('Item removed from cart');
    }else{
      this.alertService.danger('You must be logged in or continue as a guest to view your cart');
    }
  }

  saveGuestCart() {
    const guestCart = this.cartItems.map(item => ({
        id: item.id || item.product_id,
        name: item.name,
        avatar: item.avatar,
        offer: item.offer || null,
        rate: item.rate || 0,
        components: item.components,
        types: item.types,
        extraproducts: item.extraproducts || [],
        selectedTypeId: item.selectedTypeId,
        selectedExtraId: item.selectedExtraId || item.selectedExtraIds || [],
        quantity: item.quantity,
        category_name: item.category_name || item.categoryName || 'Menu',
        price: item.price || this.getOriginalItemPrice(item),
        side: item.side || [],
        free_side_count: item.free_side_count || item.free_side || 0
    }));
    
    sessionStorage.setItem('cartItems', JSON.stringify(guestCart));
  }

  placeOrderWithCash(){
    if(this.deliveyOption == 'pickup'){
      this.setEmptyAddress()
    }
    const number = this.phoneNumber.replace(/\D/g, '');
    this.isLoadingPlaceOrder = true
    this.checkoutFormWithToken.patchValue({
      deliveryNote: this.note,
      deliveryPhone: number,
      copon_id: localStorage.getItem('couponId'),
      deliveryMethod: localStorage.getItem('deliveryOption')
    })
    
    const token = localStorage.getItem('romaPizza_token')?.toString();
    if(token){
      this.checkoutFormWithToken.patchValue({
        address: this.mainAddress.address,
        longitude: this.mainAddress.longitude,
        latitude: this.mainAddress.latitude
      })
    }
    this.informationDetailsForm.markAllAsTouched();
    console.log('placeOrderWithCash: ', this.checkoutFormWithToken.value)
    console.log('phone? ', this.checkoutFormWithToken.get('deliveryPhone')?.value)
    if(this.checkoutFormWithToken.valid){
      this.apiService.confirmOrder(this.checkoutFormWithToken.value).subscribe({
        next: (response) => {
          this.orderId = response.data.id;
          this.alertService.success(response.message);
          this.router.navigate([`/order-success/${this.orderId}`]);
        }, 
        error: (error) => {
          this.alertService.danger(error.error.message);
          this.isLoadingPlaceOrder = false
        }
      });
    }else{
      if(this.checkoutFormWithoutToken.get('address')?.value == "" || 
        this.checkoutFormWithoutToken.get('longitude')?.value == "" || 
        this.checkoutFormWithoutToken.get('latitude')?.value == "" || 
        this.checkoutFormWithoutToken.get('deliveryPhone')?.value == "" || 
        this.checkoutFormWithoutToken.get('payMethod')?.value == "" || 
        this.checkoutFormWithoutToken.get('deliveryMethod')?.value == "" || 
        this.addressForm.get('country_id')?.value == "" || 
        this.addressForm.get('city_id')?.value == ""){
          this.alertService.danger('Please fill all required fields');
      }
      this.isLoadingPlaceOrder = false
    }
  }

  placeOrderWithoutTokenWithCash(){
    this.isLoadingPlaceOrder = true
    if(this.deliveyOption == 'pickup'){
      this.setEmptyAddress()
    }
    this.checkoutFormWithoutToken.patchValue({
      deliveryNote: this.informationDetailsForm.get('note')?.value,
      deliveryPhone: this.informationDetailsForm.get('phoneNumber')?.value,
      fullname: this.informationDetailsForm.get('fullname')?.value,
      email: this.informationDetailsForm.get('email')?.value,
      copon_id: localStorage.getItem('couponId'),
      address: this.addressForm.get('address')?.value,
      longitude: this.addressForm.get('longitude')?.value,
      latitude: this.addressForm.get('latitude')?.value,
      deliveryMethod: localStorage.getItem('deliveryOption')
    })
    console.log('placeOrderWithoutTokenWithCash: ', this.checkoutFormWithoutToken.value)
    if( this.isGuestMode && this.checkoutFormWithoutToken.valid ){
        this.apiService.confirmOrderWithoutToken(this.checkoutFormWithoutToken.value).subscribe({
          next: (response) => {
            this.orderId = response.data.id;
            this.alertService.success(response.message);
            this.dataSubmittedSuccessfully = true;
            this.router.navigate([`/order-success/${this.orderId}`]);
          }, 
          error: (error) => {
            this.dataSubmittedSuccessfully = false;
            this.alertService.danger(error.error.message);
            this.isLoadingPlaceOrder = false
          }
        });
    }else{
      if(this.checkoutFormWithoutToken.get('address')?.value == "" || 
        this.checkoutFormWithoutToken.get('longitude')?.value == "" || 
        this.checkoutFormWithoutToken.get('latitude')?.value == "" || 
        this.checkoutFormWithoutToken.get('deliveryPhone')?.value == "" || 
        this.checkoutFormWithoutToken.get('payMethod')?.value == "" || 
        this.checkoutFormWithoutToken.get('deliveryMethod')?.value == "" || 
        this.addressForm.get('country_id')?.value == "" || 
        this.addressForm.get('city_id')?.value == ""){
          this.alertService.danger('Please fill all required fields');
      }
      this.isLoadingPlaceOrder = false
    }
  }
}